/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import styled from "styled-components";

const Container = styled.div`
  .MuiTextField-root {
    width: 100%;
  }
`;

const PersonalInfoForm = (props) => {
  const { info, getData } = props;
  const [value, setValue] = useState({
    firstName: info.firstName,
    lastName: info.lastName,
  });

  useEffect(() => {
    getData(value);
  }, [value]);

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item lg={6} xs={12}>
          <TextField
            defaultValue={info.firstName}
            onChange={(e) =>
              setValue({
                ...value,
                firstName: e.target.value,
              })
            }
            id="outlined-basic"
            label="نام"
            variant="outlined"
          />
          <TextField
            defaultValue={info.lastName}
            onChange={(e) =>
              setValue({
                ...value,
                lastName: e.target.value,
              })
            }
            id="outlined-basic"
            label="نام خانوادگی"
            variant="outlined"
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <TextField
            InputProps={{
              readOnly: true,
            }}
            defaultValue={info.email}
            id="outlined-basic"
            label="ایمیل"
            variant="outlined"
          />
          <TextField
            InputProps={{
              readOnly: true,
            }}
            dir="ltr"
            defaultValue={info.phoneNumber}
            id="outlined-basic"
            label="شماره تماس"
            variant="outlined"
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default React.memo(PersonalInfoForm);
